import PropTypes from 'prop-types';
import { find } from 'lodash';
import { phoneFormat } from 'utils';
import moment from 'moment';
import translating from 'translate.json';

import '../style.scss';

const PersonalDetailsContent = ({ fields, data, minWidth }) => {
  const printArrayData = (arr, data) => {
    let str = '';
    arr.forEach((e) => {
      str += ` ${data[e]}`;
    });
    return str;
  };
  return (
    <div className="personal-details-content">
      <div className="personal-details-data">
        {fields?.map((item, key) => {
          return (
            <div
              key={key}
              className="personal-detail-item"
              style={{ minWidth }}
            >
              <div className="personal-detail-header">{item.label}</div>
              <div className="personal-detail-content">
                {typeof item.name === 'object' ? (
                  printArrayData(item.name, data)
                ) : item.fromOptions ? (
                  find(item?.options, { id: Number(data?.[item?.name]) })?.name
                ) : item.subField ? (
                  data?.[item?.subField]?.name
                ) : item.name === 'isActive' ? (
                  data?.[item?.name] ? (
                    translating.active
                  ) : (
                    translating.blocked
                  )
                ) : item.format === 'date' ? (
                  <>
                    <div>{moment(data?.[item?.name]).format('DD.MM.YYYY')}</div>
                    <div>{moment(data?.[item?.name]).format('HH:mm')}</div>
                  </>
                ) : item.name === 'phone' || item.name === 'mobile' ? (
                  phoneFormat(data?.[item?.name], item.name)
                ) : (
                  data?.[item?.name]
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PersonalDetailsContent;

PersonalDetailsContent.propTypes = {
  fields: PropTypes.array,
  data: PropTypes.object,
  minWidth: PropTypes.string
};
